import { environment } from 'src/environments/environment';

export const buildSsoCheckLoginUrl = (_returnUrl: string = window.location.origin): string => {
   return `${environment.ssoUrl}checklogin?returnUrl=${getReturnUrl()}`;
};

function getReturnUrl(): string {
    if (environment.isLocal === true) {
      return encodeURIComponent("http://localhost:3000");
    }
    return encodeURIComponent(window.location.origin);
  }